var map = {
	"./AbstractStrategy": 68,
	"./AbstractStrategy.js": 68,
	"./CustomStrategy": 98,
	"./CustomStrategy.js": 98,
	"./InternalErrorStrategy": 99,
	"./InternalErrorStrategy.js": 99,
	"./StrategyFactory": 100,
	"./StrategyFactory.js": 100
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 430;


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/RetryStrategy ^\.\/.*$
// module id = 430
// module chunks = 0